var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2990_4329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77507 9.36065L14.1524 15.7383C14.328 15.9135 14.4247 16.1477 14.4247 16.3975C14.4247 16.6474 14.328 16.8815 14.1524 17.0569L13.5936 17.6155C13.4183 17.7912 13.1839 17.8879 12.9342 17.8879C12.6844 17.8879 12.4503 17.7912 12.2749 17.6155L4.6816 10.0223C4.50544 9.8463 4.40898 9.6111 4.40967 9.36107C4.40898 9.10993 4.5053 8.87501 4.6816 8.69886L12.2678 1.11306C12.4433 0.937317 12.6774 0.840576 12.9273 0.840576C13.177 0.840576 13.4111 0.937317 13.5867 1.11306L14.1454 1.6716C14.5089 2.03514 14.5089 2.62695 14.1454 2.99035L7.77507 9.36065Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2990_4329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.0474,
    height: 17.0474,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.893494 17.8879)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.8bd1e4d23fcbb955bf3d495fde11eb89.svg";
export { ForwardRef as ReactComponent };